export default {
  cancelText: 'åæ¶',
};
